import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { useNavigate } from 'react-router-dom';
import './not-found.page.scss';

/**
 * Page affichée lorsqu'aucune route ne correspond à l'URL demandée.
 * @constructor
 */
export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Box className="notFoundPage">
            <Paper elevation={0} className="notFoundPage__panel">
                <Stack spacing={3} alignItems="flex-start">
                    <Box className="notFoundPage__badge" aria-hidden="true">
                        <SearchOffOutlinedIcon />
                    </Box>

                    <Stack spacing={1}>
                        <Typography variant="h1">404</Typography>
                        <Typography variant="h3">Page introuvable</Typography>
                        <Typography variant="body1" className="notFoundPage__text">
                            L&apos;adresse demandée n&apos;existe pas ou n&apos;est plus disponible.
                        </Typography>
                    </Stack>

                    <Button
                        variant="contained"
                        startIcon={<HomeOutlinedIcon />}
                        sx={{
                            backgroundColor: '#3766A5',
                            '&:hover': {
                                backgroundColor: '#23387b',
                            },
                        }}
                        onClick={() => navigate('/')}
                    >
                        Retour a l&apos;accueil
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
}
